const getMaskForMomentFormat = (format) => {
  // TODO: make this a lot better to be compatible with many more formats
  const mask = []
  for (let i = 0; i < format.length; i++) {
    const curr = format.charAt(i)
    let retExpr = curr
    if (curr >= 'a' && curr <= 'z') retExpr = /\d/
    if (curr >= 'A' && curr <= 'Z') retExpr = /\d/
    mask.push(retExpr)
  }
  return mask
}

// need to adjust string because mask directive sometimes leaves a placeholder char at the end
// or sometimes inside the string
const adjustMask = (val) => {
  if (typeof val === 'string') return val.replace('_', '')
  return val
}

export { getMaskForMomentFormat, adjustMask }
